var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 48C37.405 48 48.1502 37.2548 48.1502 24C48.1502 10.7452 37.405 0 24.1501 0C10.8953 0 0.150146 10.7452 0.150146 24C0.150146 37.2548 10.8953 48 24.1501 48Z",
    fill: "#172852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4824 10.7257C22.2928 9.6745 25.456 9.6721 28.3192 10.5361C32.0464 11.6929 35.1928 14.5057 36.8368 18.0361C37.2903 19.0417 37.7248 20.0905 37.768 21.2089C35.6728 19.9945 33.376 19.2073 31.0744 18.4897C27.3928 17.1625 23.5384 16.2409 20.0536 14.4169C19.2424 13.9321 18.208 13.4353 17.9872 12.4249C17.8984 11.5513 18.8224 11.0641 19.4824 10.7257Z",
    fill: "#FFD83D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 19.2217C11.8118 17.0137 13.1462 14.9641 14.9582 13.4449C15.419 17.2345 17.0318 20.8969 19.6958 23.6521C22.8902 26.9713 27.4406 29.0089 32.0702 28.9321C33.9086 28.9897 35.7062 28.5649 37.499 28.2217C35.735 34.5961 28.7486 38.8273 22.2758 37.8097C18.3686 37.3105 14.7614 34.9969 12.5846 31.7305C10.1294 28.1209 9.51018 23.3281 10.9982 19.2217Z",
    fill: "#FFD83D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0741 18.4896C33.3757 19.2072 35.6725 19.9944 37.7677 21.2088L37.9093 21.2832C38.1037 22.7448 38.2453 24.2352 37.9861 25.6992C36.9325 25.2528 36.0781 24.468 35.1853 23.7744C33.4669 22.344 31.7125 20.7072 31.0741 18.4896Z",
    fill: "#FF6F03"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerra);
export default __webpack_public_path__ + "static/media/Terra.ca67148d1bb7e2d4b6a9c9051c910035.svg";
export { ForwardRef as ReactComponent };